var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from 'react';
import classNames from 'classnames';

import './Toggle.scss';

var Toggle = function Toggle(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        description = _ref.description,
        _ref$inputProps = _ref.inputProps,
        inputProps = _ref$inputProps === undefined ? {} : _ref$inputProps,
        isDisabled = _ref.isDisabled,
        isOn = _ref.isOn,
        _ref$isToggleRightAli = _ref.isToggleRightAligned,
        isToggleRightAligned = _ref$isToggleRightAli === undefined ? false : _ref$isToggleRightAli,
        label = _ref.label,
        name = _ref.name,
        onChange = _ref.onChange;

    var classes = classNames('toggle-container', className, {
        'is-toggle-right-aligned': isToggleRightAligned
    });
    var toggleElements = [React.createElement('div', { key: 'toggle-simple-switch', className: 'toggle-simple-switch' }), React.createElement(
        'div',
        { key: 'toggle-simple-label', className: 'toggle-simple-label' },
        label
    )];

    if (isToggleRightAligned) {
        toggleElements = toggleElements.reverse();
    }

    return React.createElement(
        'div',
        { className: classes },
        React.createElement(
            'label',
            { className: 'toggle-simple' },
            React.createElement('input', _extends({
                checked: isOn,
                className: 'toggle-simple-input',
                disabled: isDisabled,
                name: name,
                onChange: onChange,
                type: 'checkbox'
            }, inputProps)),
            toggleElements
        ),
        description ? React.createElement(
            'div',
            { className: 'toggle-simple-description' },
            description
        ) : null
    );
};

Toggle.propTypes = {
    className: PropTypes.string,

    /** Description of the input */
    description: PropTypes.node,
    inputProps: PropTypes.object,
    isDisabled: PropTypes.bool,

    /** Toggle state */
    isOn: PropTypes.bool,

    /** If set to true, the toggle will be aligned to the right */
    isToggleRightAligned: PropTypes.bool,

    /** Label displayed for the input */
    label: PropTypes.node.isRequired,

    /** Name of the input */
    name: PropTypes.string,

    /** change callback function called with event as the argument */
    onChange: PropTypes.func
};
export default Toggle;
import PropTypes from 'prop-types';